import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { USAGE_BAR_COLORS } from "./SubscriptionTab.consts";

// Shared by the account Subscription tab and the admin All Subscriptions table.
export const Track = styled(Stack)({
  width: "100%",
  height: 16,
  borderRadius: 2,
  overflow: "hidden",
  flexDirection: "row",
  backgroundColor: USAGE_BAR_COLORS.track
});

const LEGEND_DOT_DEFAULT_SIZE = 10;

export const LegendDot = styled(Box, { shouldForwardProp: (prop) => prop !== "size" })(({ color, size = LEGEND_DOT_DEFAULT_SIZE }) => ({
  width: size,
  height: size,
  borderRadius: "50%",
  backgroundColor: color,
  flexShrink: 0
}));
